define(
	'actions/submissions',[
	"jquery",
	"underscore",
	"backbone",
	"react",
	"dispatcher/AppDispatcher",
	"constants/actiontypes",
	"shared/crm"
	],
	function($,_,Backbone,React,AppDispatcher,Constants, CRM){
		return Backbone.Model.extend({
			init: function(params) {
			},
			isPulling: false,
			addSubmission: function(params) {
				AppDispatcher.dispatch({
					actionType: Constants.CREATED_SUBMISSION,
					data: params
				});
			},
			updatedSubmission: function(guid, params) {
				AppDispatcher.dispatch({
					actionType: Constants.UPDATED_SUBMISSION,
					submissionId: guid,
					data: params
				});
			},
			initSubmission: function(submission) {
				return {
					id: submission.guid,
					assignment_guid: submission.assignment_guid,
					created_at: submission.created_at,
					updated_at: submission.updated_at,
					grade: submission.grade,
					owner_guid: submission.owner_guid,
					owner_name: submission.owner ? (submission.owner.last_name +" "+ submission.owner.first_name).toLowerCase() : "",
					responses: submission.responses,
					remarks: submission.remarks,
					turned_in_at: submission.turned_in_at,
					turned_back_at: submission.turned_back_at,
					state: submission.state
				};
			},
			pull: function(onComplete) {
				var self = this;
				var submissions = [];

				this.isPulling = true;
				
				window.api.request("submissions").each(function iterator (index, item) {
					submissions.push(self.initSubmission(item.data));
				}, function () {
					self.isPulling = false;
					self.addSubmission(submissions);

					if (typeof onComplete === "function") {
						onComplete();
					}
				});
			},
			pullByOwner: function(ownerGuid, onComplete) {
				var self = this;
				var submissions = [];
				var params = { user_guid: ownerGuid };

				this.isPulling = true;

				window.api.request("submissions", params).each(function iterator (index, item) {
					submissions.push(self.initSubmission(item.data));
				}, function() {
					self.addSubmission(submissions);

					if(typeof onComplete == "function")
						onComplete();
				});
			},
			pullFromClass: function(classId) {
				var self = this;
				var submissions = [];
				var params = { section_guid: classId };

				this.isPulling = true;

				window.api.request("submissions", params).each(function iterator (index, item) {
					submissions.push(self.initSubmission(item.data));
				}, function() {
					// self.isPulling = false;
					self.addSubmission(submissions);
				});
			},
			pullByAssignment: function(assignmentId, callback) {
				var self = this;
				var submissions = [];
				var params = { assignment_guid: assignmentId };

				this.isPulling = true;

				window.api.request("submissions", params).each(function iterator (index, item) {
					submissions.push(self.initSubmission(item.data));
				}, function() {
					self.isPulling = false;
					self.addSubmission(submissions);

					if(typeof callback == "function")
						callback();
				})
			},
			createSubmission: function(assignment_guid) {
				var self = this;

				window.api.request("submissions", null).create({'assignment_guid':assignment_guid}).done(function(response) {
					self.addSubmission(self.initSubmission(response.data));
				});
			},
			updateSubmission: function(guid, params, section_guid) {
				var self = this;

				window.api.request("submissions", guid).update({'data' : JSON.stringify(params)}).done(function(response) {
					self.updatedSubmission(guid, self.initSubmission(response.data));
				});
			},
			turnIn: function(guid) {
				var self = this;

				window.api.request("submissions/" + guid + "/turn-in").create({}).done(function(response) {
					self.updatedSubmission(guid, self.initSubmission(response.data));
				});
			},
			turnBack: function(guid, remarks) {
				var self = this;

				window.api.request("submissions/" + guid + "/turn-back").create({remarks: remarks}).done(function(response) {
					self.updatedSubmission(guid, {
						turned_in_at: null,
						remarks: remarks,
						turned_back_at: response.data.turned_back_at,
					});
				});
			},
			gradeSubmission: function(guid, grade, remarks, options) {
				var self = this;

				if(grade.length > 16) {
					if(options && typeof options.failure == "function") {
						options.failure("Grade should be max. of 16 characters.");
					}
					return;
				}

				window.api.request("submissions/" + guid + "/grade").create({grade: grade, remarks: remarks}).done(function(response) {
					self.updatedSubmission(guid, {
						grade: grade,
						remarks: remarks,
						turned_back_at: null
					});

					if(options && typeof options.success == "function") {
						options.success();
					}
				});
			},
			deleteSubmission: function(guid, section_guid) {
				var self = this;

				window.api.request("submissions", guid).delete({'data':''}).done(function() {
					self.refreshSubmissions(section_guid);
				});
			},
			refreshSubmissions : function(section_guid) {
				AppDispatcher.dispatch({
					actionType: Constants.CLEAR_SECTION_CACHE,
					data:{
						section_guid: section_guid
					}
				});
				this.pull();
			},
			createSubmissionResponse: function(submission_guid, params) {
				var self = this;

				window.api.request("submissions/"+submission_guid+"/responses", null).create(params).done(function(response) {
					//console.log("Submission response created for submission" + submission_guid);
					AppDispatcher.dispatch({
						actionType: Constants.CREATED_SUBMISSION_RESPONSE,
						submissionId: response.data.submission_guid,
						data: response.data
					});
					CRM.event('submission:create', response.data);
				});
			},
			gradeSubmissionResponse: function(submission_guid, response_guid, grade, section_guid) {
				var self = this;

				window.api.request("submissions/"+submission_guid+"/responses", response_guid).update({grade: grade}).done(function(response) {
					AppDispatcher.dispatch({
						actionType: Constants.UPDATED_SUBMISSION_RESPONSE,
						submissionId: submission_guid,
						responseId: response_guid,
						data: {grade: grade}
					});
					CRM.event('submission:grade', {grade:grade});
				});
			},
			deleteSubmissionResponse: function(submission_guid, response_guid, section_guid) {
				var self = this;

				window.api.request("submissions/"+submission_guid+"/responses", response_guid).delete().done(function(response) {
					AppDispatcher.dispatch({
						actionType: Constants.DELETED_SUBMISSION_RESPONSE,
						submissionId: submission_guid,
						responseId: response_guid
					});
					CRM.event('submission:delete', {guid: submission_guid});
				});
			}
		});
	}
);
